export const SPECIAL_SERVICES = {
    EXPRESS: "Express",
    TRUCKING: "Trucking",
    AIR_FREIGHT: "Air Freight",
} as const;
